/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  app: "App",
  appIconTooltipInfo:
    "This logo appears on the educational screen alongside the Volts logo.",
  branding: "Branding",
  brandingIsNotActive: "Branding is not active",
  brandingIsNotActiveDetails:
    "Custom branding haven't been configured. Checkout uses default Volt branding.",
  checkoutBranding: "Checkout branding",
  checkoutBrandingInactiveMessage:
    "Branding is not active, checkout uses default Volt branding",
  checkoutBrandingNew: "Checkout 3 Branding",
  checkoutBrandingOld: "Checkout Branding",
  colors: "Colors",
  companyLogo: "Company logo",
  companyLogoRecommendedRatio: "Recommended aspect ratio {{ratio}}",
  companyLogoRecommendedRatioOtherwise:
    "Recommended aspect ratio {{ratio}}, otherwise it might not display properly",
  companyLogoRequirements: "Please provide images, max. size: {{maxSizeMB}}MB",
  configuration: "Configuration",
  configure: "Configure",
  configureCustomBranding: "Configure custom branding",
  custom: "Custom",
  customerDetails: "Customer details",
  customerName: "Customer name",
  default: "Default",
  defaultColor: "{{color}} (default)",
  desktop: "Desktop",
  dragAndDropImage: "Drag and drop image, or click to select files",
  edit: "Edit",
  hidden: "Hidden",
  hideVoltBranding: "Hide Volt logo on educational screen",
  information: "Information",
  insideQR: "Inside QR code",
  linkColor: "Link color",
  linkTextColor: "Link text color",
  maximumFileSize: "Maximum file size: {{size}}MB",
  merchantLogo: "Merchant logo",
  minimalSize: "Minimal size: {{x}}x{{y}}",
  mobile: "Mobile",
  new: "New",
  newCheckoutExperienceRollingOut: "New Checkout experience rolling out",
  newCheckoutExperienceRollingOutDetails:
    "We’re gradually updating customers to our new Checkout. If you’re unsure which version is active for your account, support can assist you at any time.",
  pleaseProvideValidImageFile: "Please provide valid image file",
  primaryColor: "Primary color",
  primaryColorTooltipInfo:
    "Used for buttons, inputs, and other controls. This should match your brand's main color.",
  primaryTextColor: "Primary text color",
  removingLogoFailed: "Removing logo failed, please try again",
  save: "Save",
  secondaryColor: "Secondary color",
  secondaryColorTooltipInfo:
    "Used for accents like icons, progress bars, and backgrounds. By default it syncs with primary color.",
  secondaryTextColor: "Secondary text color",
  selectCustomer: "Select customer",
  sidebarColor: "Sidebar color",
  sidebarTextColor: "Sidebar text color",
  status: "Status",
  summaryIconTooltipInfo:
    "This logo will appear on the summary screen in a bottom sheet. This only appears on the hosted checkout",
  summaryLogo: "Summary Logo",
  tagline: "Tagline",
  toViewCheckoutBrandingSelectCustomer:
    "To view Checkout branding preferences, please select a customer in the select customer menu in the upper left corner.",
  uploadingLogoFailed: "Uploading logo failed, please try again",
  useCustomBranding: "Create your own custom checkout experience",
  useDefaultVoltBranding: "Use default Volt branding",
  visible: "Visible",
  voltBranding: "Volt branding",
  voltBrandingConfigurationTooltipInfo:
    "By selecting below checkboxes you can hide Volt branding on the Checkout.",
  voltBrandingVisibility: "Volt logo on educational screen",
};
